export default __webpack_public_path__ + "static/tiempos-text-web-regular-09b7462ae2301634e82c0300f9f71fe0.woff2";